import PhoneMissedOutlinedIcon from '@mui/icons-material/PhoneMissedOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import AddIcCallRoundedIcon from '@mui/icons-material/AddIcCallRounded';

export const PRIORITIES_ACTIVITIES_ICONS = {
  MISSEDCALL: PhoneMissedOutlinedIcon,
  SMS: SmsOutlinedIcon,
  APPOINTMENT: CalendarMonthOutlinedIcon,
  RECALL: AddIcCallRoundedIcon,
  CALL: PhoneOutlinedIcon,
};

export const PRIORITIES_ACTIVITIES_COLORS = {
  MISSEDCALL: '#CB1D1D',
  SMS: '#220676',
  APPOINTMENT: '#0074A6',
  RECALL: '#1F7804',
  CALL: '#faa700',
};
